import React, { useEffect, useRef, useState } from 'react';
import '../../Static/priceinfo.css';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useMediaQuery, Button } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import ReactToPrint from 'react-to-print';
import { Grid, Paper } from '@mui/material';
import { selectPressRegPro, selectTrimData } from '../Selectors/StitchSelector/StitchingSelectors';
import { fetchTrimmingReg } from '../../Store/PHPSlice/Trimming/TrimApi';
import { fetchPressRegProduction } from '../../Store/PHPSlice/Press/PressingApi';
import FirmHeaderImg from '../FieldsComponents/FirmHeaderImg';
import axios from 'axios';


const PackFlowInfo = () => {
    const [formData, setFormData] = useState({
        dt: '',
        empNm: '',
        itemNm: '',
        sono: '',
        soId: '',
        totqty: '',
        instruction: '',
        firmId: ''
    });
    const userdata = JSON.parse(localStorage.getItem('user'));
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const [packdata, setPackdata] = useState([]);
    const { Id } = useParams();
    const dispatch = useDispatch();
    const isDesktop = useMediaQuery('(min-width:768px)');
    const componentRef = useRef(); // Ref for the component to be printed
    useEffect(() => {
        fetchPackFlowWise(Id);
    }, [Id, dispatch]);

    const fetchPackFlowWise = async (id) => {
        try {
            const res = await axios.get(`${baseUrl}?apicall=getFlowWisePackingReg&pkid=${id}`);
            const item = res.data?.data;
            setFormData(prev => ({
                ...prev,
                date: item.date,
                empId: item.empId,
                empNm: item.empNm,
                firmId: item.firmId,
                fpkmemo: item.fpkmemo,
                instruction: item.instruction,
                itemId: item.itemId,
                itemNm: item.itemNm,
                m1: item.m1,
                m1clothNm: item.m1clothNm,
                m2: item.m2,
                m2clothNm: item.m2clothNm,
                m3: item.m3,
                m3clothNm: item.m3clothNm,
                mcloth: item.mcloth,
                mclothNm: item.mclothNm,
                ordtype: item.ordtype,
                prnId: item.prnId,
                prnMemo: item.prnMemo,
                reMemo: item.reMemo,
                soId: item.soId,
                sono: item.sono,
                stinwId: item.stinwId,
                totqty: item.totqty
            }))
            setPackdata(res.data.info);
        } catch (error) {
            console.error('error', error);
        }
    };



    const tableContainerStyle = {
        marginLeft: isDesktop ? '5%' : '0%',
        width: isDesktop ? '90%' : '100%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none'
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',  // Ensure the x-axis scrollbar is visible
        overflowY: 'hidden', // Hide the y-axis scrollbar
        WebkitOverflowScrolling: 'touch', // Enable smooth scrolling on iOS
    };



    return (
        <>
            <Grid item xs={12}>
                <Paper style={{ padding: '3vh', margin: '0' }}>
                    <div style={{ margin: '1%', width: '100%' }} ref={componentRef}>
                        {formData?.firmId !== '' && <FirmHeaderImg firmId={formData.firmId} />}
                        <h3 className='centered-heading'>Packing Info</h3>
                        <div className="dashed-line"></div>

                        <table style={{ margin: '1% 5%', fontSize: '14px' }}>
                            <tbody>
                                <tr>
                                    <td style={{ width: '200px' }}>Date</td>

                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.date}</td>

                                    <td style={{ width: '200px' }}>Packing Memo No.</td>

                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.fpkmemo}</td>

                                </tr>

                                <tr>
                                    <td style={{ width: '200px' }}>Order Type</td>

                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.ordtype}</td>

                                </tr>

                                <tr>
                                    <td style={{ width: '200px' }}>Iron Inward Memo No.</td>

                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.prnMemo}</td>

                                    <td style={{ width: '200px' }}>Stitching Inward Memo No.</td>

                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.reMemo}</td>

                                </tr>

                                {formData.soId !== '0' &&

                                    <tr>
                                        <td style={{ width: '200px' }}>Sale Order No.</td>

                                        <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.sono}</td>

                                    </tr>
                                }
                                <tr>
                                    <td style={{ width: '200px' }}>Master</td>

                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.empNm}</td>
                                    <td style={{ width: '200px' }}>Item</td>

                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.itemNm}</td>


                                </tr>
                                <tr>
                                    <td style={{ width: '200px' }}>Issue Qty.</td>

                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.totqty}</td>
                                </tr>

                            </tbody>
                        </table>
                        <table style={{ margin: '1% 5%', fontSize: '14px' }}>

                            <tbody>


                                <tr>
                                    <td style={{ width: '100px' }}>Main Cloth</td>

                                    <td style={{ width: '40vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.mclothNm}</td>

                                </tr>

                                {formData.m1 !== '0' &&
                                    <tr>
                                        <td style={{ width: '100px' }}>Matching-1</td>

                                        <td style={{ width: '40vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.m1clothNm}</td>
                                    </tr>
                                }

                                {formData.m2 !== '0' &&
                                    <tr>
                                        <td style={{ width: '100px' }}>Matching-2</td>

                                        <td style={{ width: '40vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.m2clothNm}</td>
                                    </tr>
                                }

                                {formData.m3 !== '0' &&
                                    <tr>
                                        <td style={{ width: '100px' }}>Matching-3</td>

                                        <td style={{ width: '40vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.m3clothNm}</td>
                                    </tr>
                                }


                            </tbody>

                        </table>
                        <table style={{ margin: '1% 5%', fontSize: '14px' }}>

                            <tbody>
                                <tr>

                                    <td style={{ width: '200px' }}>Packing Instructions</td>

                                    <td style={{ width: '800px', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.instruction}</td>

                                </tr>
                            </tbody>
                        </table>

                        <table style={{ margin: '1% 5%', fontSize: '14px' }}>
                            <thead>
                                <th>Size</th>
                                <th>Given {formData.ordtype} Qty</th>
                                <th>Issue Qty</th>
                                <th>Bal Qty</th>
                            </thead>
                            <tbody>
                                {packdata?.map((item, index) => (
                                    <tr key={index}>
                                        <td>{item.size}</td>
                                        <td>{item.issqty}</td>
                                        <td>{item.issqty}</td>
                                        <td>{item.balqty}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>

                    </div>
                    <div style={{ margin: '2% 5%', paddingBottom: '2%' }}>
                        <ReactToPrint
                            trigger={() => <Button variant="contained" color="primary">Print</Button>}
                            content={() => componentRef.current}
                        />
                    </div>
                </Paper>
            </Grid>
        </>
    );
};

export default PackFlowInfo;
